import * as typography from '../../tokens/typography';

export * from './Body';
export * from './Button';
export * from './Caption';
export * from './Display';
export * from './Footnote';
export * from './Headline';
export * from './Paragraph';
export * from './Underline';

export type TypographyTypes = keyof typeof typography;
